import { Trans } from '@lingui/react/macro';
import { type ReactNode } from 'react';

import { Button, LinkButton } from '@/components/buttons';
import { Results } from '@/components/Results';
import { ROUTES } from '@/router';

const Error404 = ({ title, subtitle }: { title?: ReactNode; subtitle?: ReactNode }) => {
  return (
    <Results
      status="warning"
      title={title ?? <Trans>The page you are looking for can't be found.</Trans>}
      subtitle={
        subtitle ?? (
          <Trans>
            This can happen when you follow a link to something that has since been deleted. Check
            that you typed the address correctly, go back to your previous page or return to the
            home page.
          </Trans>
        )
      }
      extra={
        <div className="flex flex-col gap-2">
          <Button variant="primary" onClick={() => history.back()}>
            <Trans>Return to the previous page</Trans>
          </Button>
          <LinkButton to={ROUTES.app.path}>
            <Trans>Go to the homepage</Trans>
          </LinkButton>
        </div>
      }
      isFullPage
    />
  );
};

export default Error404;
